module.exports = "/_next/static/resources/art-0e09ee84d67e81cd70f16ceaf47b6ecc.webp";